import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '@theme/directives/directives';
import { PipesModule } from '../helpers/pipes/pipes.module';
import { CdkDetailRowDirective } from './cdk-detail-row.directive';
import { DateSuffix } from './date-suffix';
import { BoostShiftComponent, BoostSummaryComponent } from './componets/boost-shift/boost-shift.component';
import { MaterialMdcModule } from './material-mdc.module';
import { StopPropagationDirective } from './directives/stop-propagation.directive';
import { BillRatePipe } from './pipes/bill-rate.pipe';
import { BoostRenamePipe } from './pipes/boost-rename.pipe';

@NgModule({
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    DirectivesModule,
    PipesModule,
    CdkDetailRowDirective,
    DateSuffix,
    BoostShiftComponent,
    BoostSummaryComponent,
    StopPropagationDirective,
    BillRatePipe,
    BoostRenamePipe,
  ],
  imports: [
    MaterialMdcModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule
  ],
  declarations: [
    CdkDetailRowDirective,
    DateSuffix,
    BoostShiftComponent,
    BoostSummaryComponent,
    StopPropagationDirective,
    BillRatePipe,
    BoostRenamePipe
  ]
})
export class SharedModule {
}
